import { ConfirmDialog } from '@/components/ConfirmDialog';
import { Stack, Text } from '@/ui';
import { Link } from '@/ui/primitives';
import type { ReactElement } from 'react';

type OnboardingDisclaimerDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const OnboardingDisclaimerDialog = ({
  open,
  onClose,
}: OnboardingDisclaimerDialogProps): ReactElement => (
  <ConfirmDialog
    open={open}
    title="Disclaimer"
    confirmLabel="Got It"
    confirmColor="primary"
    confirmVariant="contained"
    hideCancel
    disableClose
    onClose={onClose}
    onConfirm={onClose}
    maxWidth="xs"
  >
    <Stack gap="md">
      <Text role="body">Thanks for trying FlowQA!</Text>
      <Text role="body" color="textSecondary">
        FlowQA is currently in beta. While core features are stable, you may encounter occasional
        issues as we continue to refine and improve the platform.
      </Text>
      <Text role="body">Your feedback helps shape the product as it evolves.</Text>
      <Text role="body" color="textSecondary">
        Feel free to get in touch using the Feedback link at the bottom of the sidebar or emailing{' '}
        <Link href="mailto:support@flowqa.com">support@flowqa.com</Link>.
      </Text>
    </Stack>
  </ConfirmDialog>
);
